import 'dayjs/locale/es';

import dayjs from 'dayjs';

import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider as Provider } from '@mui/x-date-pickers/LocalizationProvider';

type Props = {
  children: React.ReactNode;
};

dayjs.locale('es'); // ✅ mueve esto fuera del componente para asegurar que se aplica una vez

export function LocalizationProvider({ children }: Props) {
  return (
    <Provider dateAdapter={AdapterDayjs} adapterLocale="es">
      {children}
    </Provider>
  );
}
